import { CustomInput as InputForm } from "@/components/Input";
import { useCart } from "@/contexts";
import { useIsomorphicLayoutEffect } from "@/hooks/Custom";
import { CartPrice } from "@/types";
import { formatPrice } from "@/utils";
import { useCardBrand } from "@/utils/useCardBrand";
import { useInstallment } from "@/utils/useInstallment";
import { useInstallmentNew } from "@/utils/useInstallmentNew";
import {
  Flex,
  Image,
  InputGroup,
  InputRightElement,
  Select,
  Text,
  useBreakpointValue
} from "@chakra-ui/react";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

type CreditFormProps = {
  Total: string;
  TotalNumber: number;
  SubTotal: number;
  Freigth: number;
  CCHolder: string;
  CCNumber: string;
  CCMonth: string;
  CCYear: string;
  CSCode: string;
  CPFNumber: string;
  setCCH: Dispatch<SetStateAction<string>>;
  setCCN: Dispatch<SetStateAction<string>>;
  setCCM: Dispatch<SetStateAction<string>>;
  setCCY: Dispatch<SetStateAction<string>>;
  setCSC: Dispatch<SetStateAction<string>>;
  setCSI: Dispatch<SetStateAction<number>>;
  setCPF: Dispatch<SetStateAction<string>>;
  Cart: any;
};

function CreditForm({
  Total,
  TotalNumber,
  Freigth,
  SubTotal,
  CCHolder,
  CCMonth,
  CCNumber,
  CCYear,
  CSCode,
  CPFNumber,
  setCCH,
  setCCM,
  setCCN,
  setCCY,
  setCSC,
  setCSI,
  setCPF,
  Cart
}: CreditFormProps) {
  const { cartInstallmentsNumber, changeCartInstallmentsNumber } = useCart();

  const [CardIcon, setCardIcon] = useState(null);

  const [Installments, setInstallments] = useState<CartPrice[]>(null);

  const [Desc, setDesc] = useState<string>(
    Installments?.[cartInstallmentsNumber > 0 ? cartInstallmentsNumber : 1]?.desc
  );

  const [valuePrice, setValuePrice] = useState<any>(cartInstallmentsNumber);

  const [toSplitDate, setToSplitDate] = useState(null);

  useEffect(() => {
    if (toSplitDate) {
      const newDate = toSplitDate.split("/");
      setCCM(newDate[0]);
      setCCY(newDate[1]);
    }
  }, [toSplitDate]);

  const Wide = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  useIsomorphicLayoutEffect(() => {
    if (TotalNumber) {
      const Prices = useInstallmentNew(Cart, Freigth);
      console.log("OLHA O Prices", Prices);
      if (cartInstallmentsNumber !== null) {
        let def = Prices?.filter((p) => p.parcel === cartInstallmentsNumber)[0];
        setDesc(def?.desc);
        setCSI(def?.parcel);
        setValuePrice(cartInstallmentsNumber > 0 ? cartInstallmentsNumber : 1);
      }
      setInstallments(Prices);
    }
  }, [TotalNumber, cartInstallmentsNumber]);

  useIsomorphicLayoutEffect(() => {
    if (CCNumber) {
      let CardBrand = useCardBrand(CCNumber);
      if (CardBrand) setCardIcon(CardBrand);
    }

    return () => {
      setCardIcon(null);
    };
  }, [CCNumber]);

  return (
    <Flex direction={"column"} gap={"10px"} mt={"1rem"}>
      {/* INSTALLMENTS */}
      <Flex>
        <Select
          name="Installments"
          id={"PaymentInstallments"}
          onChange={(e) => {
            setValuePrice(e.target.value);
            setCSI(parseFloat(e.target.value));
            setDesc(e.target.selectedOptions[0].getAttribute("about"));
            changeCartInstallmentsNumber(parseInt(e.target.value));
          }}
          border={"1px"}
          borderColor={"ll-gray.100"}
          height={"48px"}
          borderRadius="50px"
          _placeholder={{ color: "gray.300" }}
          _focus={{ borderColor: "#0C4EA2" }}
          _hover={{ borderColor: "#0C4EA2" }}
          bgColor="ll-gray.600"
          variant="filled"
        >
          {Installments &&
            Installments?.slice(1).map((parcel) => (
              <>
                <option
                  key={parcel.parcel}
                  value={parcel.parcel}
                  about={parcel.desc}
                  selected={cartInstallmentsNumber === parcel.parcel}
                >
                  {`${parcel.desc}`}&nbsp;• Total =&nbsp;
                  {formatPrice(parcel.parcel * parcel.value)}
                </option>
              </>
            ))}
        </Select>
      </Flex>
      {/* HOLDER NAME */}
      <Flex>
        <InputForm
          name="HolderName"
          id={"PaymentCardHolderName"}
          type="text"
          placeholder={"TITULAR"}
          value={CCHolder}
          onChange={(e) => setCCH(e.target.value.toUpperCase())}
          p={"0 0 0 10px"}
          width={"full"}
          border={"1px"}
          borderColor={"ll-gray.100"}
          height={"48px"}
          borderRadius="50px"
        />
      </Flex>
      {/* CARD NUMBER */}
      <Flex>
        <InputGroup>
          <InputForm
            name="CardNumber"
            id={"PaymentCardNumber"}
            placeholder={"NÚMERO DO CARTÃO"}
            value={CCNumber}
            onChange={(e) => setCCN(e.target.value)}
            mask={"9999 9999 9999 9999"}
            p={"0px 0px 0px 15px"}
            type={"tel"}
            width={"full"}
            border={"1px"}
            borderColor={"ll-gray.100"}
            height={"48px"}
            borderRadius="50px"
          />
          <InputRightElement
            mr={"25px"}
            my={"4px"}
            children={
              CardIcon && <Image src={CardIcon} width="50px" alt={"Alternative to Image"} />
            }
          />
        </InputGroup>
      </Flex>
      {/* CPF CARD NUMBER */}
      <Flex>
        <InputGroup>
          <InputForm
            name="CPFNumber"
            id={"CPFCardNumber"}
            placeholder={"CPF DO TITULAR DO CARTÃO"}
            value={CPFNumber}
            onChange={(e) => setCPF(e.target.value)}
            mask={"999.999.999-99"}
            p={"0px 0px 0px 15px"}
            type={"tel"}
            width={"full"}
            border={"1px"}
            borderColor={"ll-gray.100"}
            height={"48px"}
            borderRadius="50px"
          />
          <InputRightElement
            mr={"25px"}
            my={"4px"}
            children={
              CardIcon && <Image src={CardIcon} width="50px" alt={"Alternative to Image"} />
            }
          />
        </InputGroup>
      </Flex>
      {/* EXPIRE DATE [MONTH & YEAR] */}
      <Flex>
        <InputForm
          name="ExpireMonthAndYear"
          id={"PaymentCardExpirationDate"}
          width={Wide ? "49%" : "45%"}
          placeholder={Wide ? "DATA DE VENCIMENTO" : "VENCIMENTO"}
          flex={1}
          value={toSplitDate}
          onChange={(e) => {
            setToSplitDate(e.target.value);
          }}
          p={"0 0 0 10px"}
          mask={"99/2099"}
          type={"tel"}
          mr={"1rem"}
          border={"1px"}
          borderColor={"ll-gray.100"}
          height={"48px"}
          borderRadius="50px"
        />
        {/* SECURITY CODE */}
        <InputForm
          name="SecurityCode"
          placeholder={Wide ? "CÓDIGO DE SEGURANÇA" : "CÓDIGO SEGURANÇA"}
          value={CSCode}
          id={"PaymentCardSecurityCode"}
          onChange={(e) => setCSC(e.target.value)}
          p={"0 0 0 10px"}
          mask={"999"}
          type={"tel"}
          width={Wide ? "49%" : "58%"}
          border={"1px"}
          borderColor={"ll-gray.100"}
          height={"48px"}
          borderRadius="50px"
        />
      </Flex>
      {/* <Text mt={"10px"} textStyle="Bold" color="#1E1E1E" fontSize={"15px"}>
        {Desc ? (
          <>
            {"PARCELAS: "}
            {Wide && (
              <Text as="span" textStyle="Bold" color="#1E1E1E" fontSize={"18px"}>
                {Desc}&nbsp;&nbsp; • Total = &nbsp;
                {formatPrice(Installments?.[valuePrice]?.value * valuePrice)}
              </Text>
            )}
            {!Wide && (
              <Text as="span" textStyle="Bold" color="#1E1E1E" fontSize={"18px"}>
                {Desc}&nbsp;&nbsp; <br /> • Total = &nbsp;
                {formatPrice(Installments?.[valuePrice]?.value * valuePrice)}
              </Text>
            )}
          </>
        ) : (
          <>
            {Installments && (
              <>
                <Text>Total à vista:{formatPrice(Installments[1].value)}</Text>
                <Text textStyle="Bold" mt={"10px"} color="#1E1E1E">
                  {"PARCELAS: "}
                  <Text as="span" textStyle="Bold" color="#1E1E1E">
                    1x de {formatPrice(Installments[1].value)} • Total ={" "}
                    {formatPrice(Installments[1].value)}
                  </Text>
                </Text>
              </>
            )}
          </>
        )}
      </Text> */}
    </Flex>
  );
}
export { CreditForm };
